<script setup lang="ts">
import arrowSms from '@/assets/icons/arrow-sms.svg';

defineProps<{ selectionEnabled: boolean }>();
defineEmits(['onPress', 'onCancel', 'onConfirm']);
</script>

<template>
  <div v-if="selectionEnabled" class="flex flex-col py-2 pb-2 gap-4">
    <p class="flex text-primary text-right font-bold">
      Sélectionnez les patients à qui vous souhaitez envoyer un SMS. Les patients sans numéro de téléphone valide
      (06/07) ont été retirés de la liste.
    </p>
    <div class="flex flex-row cursor-pointer">
      <div
        class="bg-primary p-2 px-4 rounded-md shadow"
        @click="$emit('onConfirm')"
      >
        <p class="text-white">
          Valider la sélection
        </p>
      </div>
      <div
        class="bg-white p-2 px-4 ml-2 rounded-md shadow"
        @click="$emit('onCancel')"
      >
        <p class="text-primary">
          Annuler
        </p>
      </div>
    </div>
  </div>
  <div
    v-else
    class="bg-white flex flex-row p-2 right-10 -bottom-4  border-primary hover:opacity-75 cursor-pointer"
    style="border-width: 1px; border-radius: 10px; box-shadow: 3px 3px #3513E2"
    @click="$emit('onPress')"
  >
    <p class="ml-2 text-primary">
      Envoyer des SMS
    </p>
    <img :src="arrowSms" alt="apodisLogo" class="h-6">
  </div>
</template>
